/** Create a pending registration-fee invoice after LMS submit (service role via edge function). */
export async function createPendingRegistrationFeeInvoice(supabase, registrationId) {
  if (!registrationId) return { success: false, error: new Error('registrationId is required') };

  try {
    const { data, error } = await supabase.functions.invoke('handle-payment-received', {
      body: {
        action: 'create_pending_registration_fee_invoice',
        registration_id: registrationId,
      },
    });

    if (error) {
      console.error('Failed to create registration fee invoice:', error);
      return { success: false, error };
    }

    return { success: true, data };
  } catch (err) {
    console.error('Failed to create registration fee invoice:', err);
    return { success: false, error: err };
  }
}
